export default __webpack_public_path__ + "static/media/3.a5b897f3.gif";